import Paper from "@material-ui/core/Paper";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { color } from "@amcharts/amcharts4/core";
import { set } from "nprogress";
import LoadingOverlay from "react-loading-overlay";
import { makeStyles } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";

import stAlbert from "assets/images/StAlbertLogo.png";
import Signature from "./img/admissionOfficerSign.png";
// import moment from "moment";
import { Box } from "@material-ui/core";

const useStyles = makeStyles({
  watermarkContainer: {
    position: "relative",
    overflow: "visible",
    minHeight: "100%",
  },
  watermarkWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    zIndex: 1,
  },
  watermarkImage: {
    width: "400px", // Adjust size as needed
    height: "120vh", // Adjust size as needed
    opacity: 0.1, // Adjust opacity as needed
    transform: "rotate(-45deg)",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "fixed", // This ensures it stays centered while scrolling
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  content: {
    position: "relative",
    zIndex: 2,
    padding: "24px",
    backgroundColor: "transparent",
  },
});

const Letter = ({ authUser, settings, applicantData }) => {
  const classes = useStyles();
  const [letterAdm, setLetterAdm] = useState(null);
  const [letterAdmFeeRows, setLetterAdmFeeRows] = useState(null);
  const [loader, setLoader] = useState(false);
  const [watermarks, setWatermarks] = React.useState([]);
  const containerRef = useRef(null);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth;
      const height = containerRef.current.offsetHeight;
      const numX = Math.ceil(width / 300); // 300 = image width + margin
      const numY = Math.ceil(height / 300); // 300 = image height + margin
      const marks = [];
      for (let y = 0; y < numY; y++) {
        for (let x = 0; x < numX; x++) {
          marks.push({ id: `${x}-${y}` });
        }
      }
      setWatermarks(marks);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { token, ApplicantID } = authUser;
        setLoader(true);
        const response = await fetchJSON(
          `api/ProvisionalAdmissionLetter00?applicantId=${ApplicantID}`,
          null,
          "GET",
          token
        );

        setLoader(false);
        setLetterAdm(response.Data.response);
        setLetterAdmFeeRows(response.Data.feeRows);
      } catch (error) {
        console.log(error);
        setLoader(false);
      }
    })();
  }, [authUser]);

  if (!isLargeScreen) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#f8d7da",
          color: "#721c24",
          fontFamily: "Roboto, sans-serif",
          fontSize: "1rem",
        }}
      >
        Sorry, this page is not accessible on screens smaller than 768px. Please
        use a larger device to view this content.
      </div>
    );
  }

  return (
    <>
      <LoadingOverlay active={loader} spinner text="Fetching Data">
        <Paper elevation={2}>
          <Box className={classes.watermarkContainer} ref={containerRef}>
            <div className={classes.watermarkWrapper}>
              <div
                className={classes.watermarkImage}
                // style={{
                //   backgroundImage: `url(${stAlbert})`,
                // }}
              />
            </div>
            <div
              style={{
                margin: 0,
                paddingTop: "60px",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <div
                id="content"
                className="container"
                style={{
                  width: "90%",
                  maxWidth: "25cm",
                  minHeight: "35cm",
                  margin: "0 auto",
                  position: "relative",
                  backgroundColor: "white",
                  padding: "20px",
                  boxSizing: "border-box",
                }}
              >
                {/* containers  */}
                <div
                  style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    right: "20px",
                    bottom: "20px",
                    pointerEvents: "none",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{ flex: 1, borderTop: "1px solid #b78e2d" }}
                    ></div>
                    <div style={{ width: "100px" }}></div>
                    <div
                      style={{ flex: 1, borderTop: "1px solid #b78e2d" }}
                    ></div>
                  </div>

                  {/* !-- Left Border Line --> */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      bottom: "75px",
                      borderLeft: "1px solid #b78e2d",
                    }}
                  ></div>

                  {/* <!-- Right Border Line --> */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: "75px",
                      borderRight: "1px solid #b78e2d",
                    }}
                  ></div>

                  <div
                    style={{
                      position: "absolute",
                      bottom: "75px",
                      left: 0,
                      right: 0,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{ flex: 1, borderBottom: "1px solid #b78e2d" }}
                    ></div>
                    <div style={{ width: "300px" }}></div>
                    <div
                      style={{ flex: 1, borderBottom: "1px solid #b78e2d" }}
                    ></div>
                  </div>

                  {/* <!-- Logo Placeholder --> */}
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      backgroundColor: "#b78e2d",
                      position: "absolute",
                      top: 0,
                      left: "45%",
                      transform: "translateX(-50%)",
                      transform: "translateY(-50%)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <span style={{color: "white", fontSize: "12px"}}>Logo</span> */}
                    <img
                      src={stAlbert}
                      alt="College Logo"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "contain",
                        position: "absolute",
                      }}
                    />
                  </div>

                  {/* <!-- Header Text --> */}
                  {applicantData.EntryModeId === 2 ? (
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "35px",
                        padding: "0 40px",
                      }}
                    >
                      <h1
                        style={{
                          margin: 0,
                          fontFamily: "Garamond, serif",
                          fontSize: "36px",
                          fontWeight: "600",
                          // color: '#006838',
                          color: "#043820",
                          letterSpacing: "1px",
                        }}
                      >
                        VERITAS INSTITUTE
                      </h1>
                      <h2
                        style={{
                          margin: "2px 0",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "18px",
                          color: "#000",
                          fontWeight: "bolder",
                          letterSpacing: "0px",
                        }}
                      >
                        HIGHER EDUCATION, KADUNA STATE
                      </h2>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          color: "#006838",
                          fontWeight: "normal",
                        }}
                      >
                        (Admission Office)
                      </h3>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "35px",
                          padding: "0 40px",
                        }}
                      >
                        <h1
                          style={{
                            margin: 0,
                            fontFamily: "Garamond, serif",
                            fontSize: "36px",
                            fontWeight: "600",
                            // color: '#006838',
                            color: "#043820",
                            letterSpacing: "1px",
                          }}
                        >
                          SAINT ALBERT INSTITUTE,
                        </h1>
                        <h2
                          style={{
                            margin: "2px 0",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "18px",
                            color: "#000",
                            fontWeight: "bolder",
                            letterSpacing: "0px",
                          }}
                        >
                          KADUNA STATE
                        </h2>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            color: "#006838",
                            fontWeight: "normal",
                          }}
                        >
                          (Admission Office)
                        </h3>
                      </div>
                    </>
                  )}

                  {/* <!-- Watermark Placeholder --> */}
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      opacity: "0.1",
                      pointerEvents: "none",
                    }}
                  >
                    <img
                      style={{
                        width: "500px",
                        height: "500px",
                        borderRadius: "50%",
                        // backgroundColor: "#006838",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      src={stAlbert}
                    />
                  </div>
                  <div className="pt-4 px-4 pb-0">
                    <div className="row">
                      <div className="col-md-6">
                        <p style={{ fontSize: "20px" }}>
                          <strong>Printed Date: </strong>{" "}
                          {new Date().toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })}
                        </p>
                      </div>
                      <div className="col-md-6 text-right">
                        <img
                          src={letterAdm?.FileUrl}
                          alt="Student"
                          style={{
                            width: "120px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>

                    <div className="mt-4">
                      <p style={{ fontSize: "20px" }}>
                        <strong>Dear {letterAdm?.FullName}</strong>
                      </p>
                    </div>

                    <div className="text-center mt-4 mb-4">
                      <h4 style={{ fontSize: "18px" }}>
                        <strong>
                          OFFER OF PROVISIONAL ADMISSION FOR{" "}
                          {letterAdm?.Session} ACADEMIC SESSION
                        </strong>
                      </h4>
                    </div>

                    <div style={{ fontSize: "16px" }}>
                      <p>
                        With reference to your application for admission, I am
                        pleased to inform you that you have been offered a
                        provisional admission into the College for the 2024/2025
                        academic session to pursue a{" "}
                        <strong>
                          {letterAdm?.YearsToGraduate} {""}{" "}
                          {letterAdm?.ModeType}
                        </strong>
                        {""} in{""} <strong>{letterAdm?.DepartmentName}</strong>
                        .
                      </p>

                      <p>If you accept this offer, you are required to:</p>
                      <ul>
                        <li>
                          Pay a non-refundable acceptance fee of Five Thousand
                          Naira Only (₦5,000) within a period of 5 days from the
                          date of issuance.
                        </li>
                        <li>
                          Register for all courses online (as appropriate).
                        </li>
                        <li>
                          Undergo a medical examination at the school medical
                          laboratory and submit the report to the registry.
                        </li>
                      </ul>

                      <p className="mt-3">
                        In addition, kindly note the following:
                      </p>
                      <ol>
                        <li>
                          Payment of school fees as well as other charges is to
                          be made at the beginning of each academic session.
                        </li>
                        <li>
                          This admission is subject to your being in possession
                          of the minimum entry qualification for the course in
                          which you have been offered admission and it is
                          subjected to verification of your original certificate
                          and other related documents.
                        </li>
                        <li>
                          Admitted candidates are expected to register within
                          the official registration period indicated in the
                          official college calendar.
                        </li>
                        <li>
                          Failure to register within the stipulated period of
                          registration would amount to automatic forfeiture of
                          the offer.
                        </li>
                        <li>
                          You will abide by the rules of the Institution's
                          academic and related regulations.
                        </li>
                        <li>
                          Resumption date is <strong>25TH January, 2025</strong>
                          .
                        </li>
                      </ol>
                    </div>

                    <p style={{ fontSize: "18px" }} className="mt-4">
                      Accept my congratulations on your admission.
                    </p>

                    <div className="text-left my-0">
                      <img
                        src={Signature}
                        alt="Registrar Signature"
                        style={{ width: "300px", height: "100px" }}
                      />
                      <h5 className="mt-2 pl-4">
                        <strong>OYERINDE O.R.</strong>
                        <br />
                        <span style={{ fontSize: "18px" }}>
                          Admissions Officer
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div
                    className="PageBottom"
                    style={{
                      fontFamily: "Roboto",
                      // position: 'relative',
                      // bottom: 0,
                    }}
                  >
                    {/* <!-- Bottom Logo Placeholder --> */}
                    <div
                      style={{
                        width: "80px",
                        // height: '80px',
                        // borderRadius: '50%',
                        // backgroundColor: '#006838',
                        // color: '#006838',
                        position: "absolute",
                        bottom: "24px",
                        left: "45%",
                        transform: "translateX(-50%)",
                        transform: "translateY(-50%)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Roboto",
                          color: "#0e2b1e",
                          fontSize: "16px",
                          textWrap: "nowrap",
                          fontWeight: "700",
                        }}
                      >
                        INSTITUTION CONTACT DETAILS
                      </p>
                    </div>

                    {/* Footer */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: "20px",
                        right: "20px",
                        textAlign: "center",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      <span
                        style={{
                          margin: "5px 0",
                          fontWeight: "normal",
                          color: "#000",
                        }}
                      >
                        <span style={{ fontWeight: "800", color: "#000" }}>
                          A:{" "}
                        </span>
                        Egbejila Road Behind Solid Worth Hotel, Asa Dam Area,
                        Ilorin, Kwara State, Nigeria
                      </span>
                      <span
                        style={{
                          margin: "5px 0",
                          fontWeight: "normal",
                          color: "#000",
                        }}
                      >
                        <span style={{ fontWeight: "800", color: "#000" }}>
                          {" "}
                          T:{" "}
                        </span>
                        +234 802 954 1012, +234 810 396 9334
                      </span>
                      <br />
                      <span
                        style={{
                          margin: "5px 0",
                          fontWeight: "normal",
                          color: "#000",
                        }}
                      >
                        <span style={{ fontWeight: "800", color: "#000" }}>
                          E:
                        </span>{" "}
                        stalbertinistute@gmail.com, www.stalbertinistute.edu.ng
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Paper>
      </LoadingOverlay>
    </>
  );
};

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;

  const settings = auth;

  return { authUser, settings };
};

export default connect(mapStateToProps, {})(Letter);
